export const convertBase64ImageToSrcFormat = (img: string) =>
  "data:image/png;base64, " + img;
